import { Phone, MessageCircle, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE, buildWhatsAppLink } from "@/lib/site-config";

export default function Header() {
  const waLink = buildWhatsAppLink(
    "Hello, I would like to know more about Gurukul Classes."
  );

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/85 backdrop-blur-md"
    >
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-3 md:px-8 md:py-4">
        {/* Logo + tagline */}
        <a
          href="#"
          data-testid="site-logo"
          className="group flex items-center gap-3"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-md bg-red-600 text-white shadow-sm transition-transform group-hover:rotate-[-3deg]">
            <BookOpen className="h-6 w-6" strokeWidth={2.2} />
          </span>
          <span className="leading-tight">
            <span className="block font-display text-lg font-extrabold tracking-tight text-slate-900 md:text-xl">
              Gurukul Classes
            </span>
            <span className="block text-[11px] font-medium uppercase tracking-[0.14em] text-red-600 md:text-xs">
              {SITE.tagline}
            </span>
          </span>
        </a>

        {/* CTAs */}
        <div className="flex items-center gap-2 md:gap-3">
          <Button
            asChild
            data-testid="header-call-btn"
            className="h-10 gap-2 rounded-full bg-red-600 px-3 text-sm font-semibold text-white shadow-sm hover:bg-red-700 md:h-11 md:px-5"
          >
            <a href={`tel:${SITE.phoneTel}`} aria-label="Call Gurukul Classes">
              <Phone className="h-4 w-4" />
              <span className="hidden sm:inline">Call Now</span>
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            data-testid="header-whatsapp-btn"
            className="h-10 gap-2 rounded-full border-emerald-600 px-3 text-sm font-semibold text-emerald-700 hover:bg-emerald-50 md:h-11 md:px-5"
          >
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat on WhatsApp"
            >
              <MessageCircle className="h-4 w-4" />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
}
